import Context from '../components/Context'
import { connect } from 'react-redux'
import { setParsedContext, setShowUploadModal, setSelectedContext, setContext, setInputKeys } from '../util/actions'
import { initInputKeys, getContextKeys, getContextFromGist } from '../util/utils'

const mapStateToProps = (state) => ({
  user: state.user,
  inputKeys: state.mapping.inputKeys,
  selectedContext: state.mapping.selectedContext,
  advancedMode: state.mapping.advancedMode,
  contextsFromVocabularies: state.mapping.contextsFromVocabularies,
  contextsFromGist: state.mapping.contextsFromGist,
  contents: state.mapping.contents
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClickUpload: () => {
    dispatch(setShowUploadModal(true, false))
  },
  clearStates: () => {
    dispatch(setSelectedContext({}))
  },
  handleChangeSelectedVocabulary: async (vocabulary, props) => {
    dispatch(setSelectedContext(vocabulary))
    if (vocabulary.type === 'gist') {
      const context = await getContextFromGist(vocabulary.uri)
      dispatch(setParsedContext((context)))
    } else {
      const newKeys = initInputKeys(props.contents, props.inputKeys)
      dispatch(setInputKeys(newKeys))
      const keys = getContextKeys(props.inputKeys, vocabulary)
      dispatch(setContext(keys))
    }
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Context)


// WEBPACK FOOTER //
// ./src/containers/Context.js